import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import EventsBackgroundColor from "./../Shared/EventsBackgroundColor";
import { BrowserView, MobileView, isBrowser, isMobile, withOrientationChange } from "react-device-detect";
import axios from "axios";
import { Route, IndexRoute } from "react-router";
import { Link } from "react-router-dom";
import ModalEventLink from '../Shared/ModalEventLink'; // Import the new component
const eventCat = require("./data/eventCategory.json");
const periodCat = require("./data/periodCategory2.json");
const { apiUrl } = require('./config')
const newTimelineData2015 = require("./data/new-timelineData-0-2015.json");
const periods = require("./data/periods.json");
const volumesJson = require("./data/volumes.json");
const timelinePeriods = require("./data/timelinePeriods.json");
// static files from endpoints
// const timeline_data = require("./../timeline_data.json");
// const timeline_periods = require("./../timeline_periods.json");
// const timeline_category = require("./../timeline_category.json");
// const timelineperiods = require("./../timelineperiods.json");

const { categObj } = require("./categ");
const { 
  getCategory

} = require("../Shared/utils");


function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function timelineListShowEvent() {
  return `${apiUrl}/api/v2/pages/?type=home.TimelineEvent&fields=*&show_event=true`
}

function getPeriodCategorySnippets() {
  var url = `${apiUrl}/api/v2/snippets/period/?fields=*`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getVolumeCategorySnippets() {
  var url = `${apiUrl}/api/v2/snippets/volume/?fields=*`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getTimelinePeriods() {
  var url = `${apiUrl}/api/v2/pages/?type=home.TimelinePeriod&fields=*`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getStaticData() {
  var url = `${apiUrl}/staticfiles/content/timeline_data.json`
  // var url = `${apiUrl}/staticfiles/timeline_data.json`
  // console.log("urlurlurl", url)
  return axios.get(url)
    .then(res => {
      // console.log("resssss", res)
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getStaticPeriods() {
  var url = `${apiUrl}/staticfiles/content/timeline_periods.json`
  // var url = `${apiUrl}/staticfiles/timeline_periods.json`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getStaticCategory() {
  var url = `${apiUrl}/staticfiles/content/timeline_category.json`
  // var url = `${apiUrl}/staticfiles/timeline_category.json`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

function getStaticTimelinePeriods() {
  var url = `${apiUrl}/staticfiles/content/timelineperiods.json`
  // var url = `${apiUrl}/staticfiles/timelineperiods.json`
  return axios.get(url)
    .then(res => {
      const data = res.data;
        return data
    })
    .catch(error => {
      console.error(error);
    });
}

class EventSliderIndex extends Component {
  state = {
    eventItem: {},
    eventId: '',
    iframeSrc: '',
    showModal: false,
    activeLinks: [], // Array to store active links
    activeModal: null, // Track the active modal
    isLoadingEventLink: false // Modal event link loading
  }

  componentWillReceiveProps = (props) => {  
    // console.log("componentWillReceivePropsxxxsss", props);
    var { eventItem } = props

    //staticfiles
    getStaticPeriods().then(output => {
      getStaticCategory().then(vol => {
        getStaticData().then( period => {
          var periodFilter = output.filter((per)=>{
            return per.id == eventItem.periods[0].id
          })
          var volFilter = vol.filter((vol)=>{
            return vol.slug == eventItem.categories[0].id
          })
          // console.log('periodFilter',periodFilter)
          // console.log('volFilter',volFilter)

          var eventItemObj = Object.assign({}, eventItem, {
            periodName: periodFilter[0].name,
            category: volFilter[0].name,
            periodId: eventItem.periods[0].id,
            categoryId: eventItem.categories[0].id,
          })

          period.forEach((period)=>{
            if(eventItemObj.periodId == period.period_id){
              this.setState({
                eventItem: eventItemObj,
                period: period
              })
            }
          })
          // console.log('eventItemObj', eventItemObj)
        })
      })
    })
  }

  handleClick = (value) => {
    window.location.replace(`/epa_timeline/#id${value}`);
  }

  handleLinkClick = (event, eventLink) => {
    event.preventDefault();
    const target = event.target;
    // console.log("handleLinkClick2", target)
    this.setState({ isLoading: true }); // Show loading indicator

    document.documentElement.style.overflow = 'hidden';

    // Check if the target is an <i> element
    if (target.tagName.toLowerCase() === 'i') {
      // Find the nearest <a> element by traversing up the DOM tree
      const anchorElement = target.closest('a');
      if (anchorElement) {
        const iframeSrc = anchorElement.href;
        // const eventId = `${eventLink}-${anchorElement.id}`;

        const eventLinkId = `${target.id}-${eventLink}`; // Combine link id and parent element id
        const eventId = `${eventLink}`; // Combine link id and parent element id

        // Remove any existing active links
        const updatedLinks = this.state.activeLinks.filter(link => link.eventId === eventLinkId);

        // Simulate an asynchronous operation (e.g., loading data)
        setTimeout(() => {
          // Add the new active link
          updatedLinks.push({ eventId, iframeSrc });

          // console.log("updatedLinks1", updatedLinks)
          
          this.setState({ activeLinks: updatedLinks, showModal: true, activeModal: eventId, isLoading: false }); // Hide loading indicator
        }, 1000); // Replace this with your actual asynchronous operation
      }
    } else {
      if (target.tagName.toLowerCase() === 'a') {
        const iframeSrc = target.href;
        // const linkId = document.querySelector('.linkActiveEvent').id;
        const eventLinkId = `${target.id}-${eventLink}`; // Combine link id and parent element id
        const eventId = `${eventLink}`; // Combine link id and parent element id

        // Remove any existing active links
        const updatedLinks = this.state.activeLinks.filter(link => link.eventId === eventLinkId);

        // Simulate an asynchronous operation (e.g., loading data)
        setTimeout(() => {
          // Add the new active link
          updatedLinks.push({ eventId, iframeSrc });

          // console.log("updatedLinks2", updatedLinks)
          
          this.setState({ activeLinks: updatedLinks, showModal: true, activeModal: eventId, isLoading: false }); // Hide loading indicator
        }, 1000); // Replace this with your actual asynchronous operation

      }
    }

  }

  closeModal = () => {
    this.setState({ isLoadingCloseModal: true }); // Show loading indicator

    document.documentElement.style.overflow = 'auto';

    setTimeout(() => {
      this.setState({ showModal: false, iframeSrc: '', activeModal: null, isLoadingCloseModal: false });
    }, 1000); // Replace this with your actual asynchronous operation
  }

  render() {
    // console.log("eventslider/STate", this.state);
    var { eventItem, period, eventId } = this.state;
    return (
      <div>
        {isEmpty(eventItem) ? (
          ""
        ) : (
          <div>
            {this.state.showModal && this.state.activeModal && this.state.activeModal === `eventLink${period.id}-${eventItem.categories[0].pk}-${eventItem.id}` && (
              <ModalEventLink
                iframeSrc={this.state.activeLinks.find(link => link.eventId === this.state.activeModal).iframeSrc}
                closeModal={this.closeModal}
                isLoading={this.state.isLoading}
              />
            )}

            <div className={`container-period col-xl-12 period-container bg-img p-0 inner`}
            style={{
              backgroundImage: `url('${period.background_image.meta.download_url}')`,
              // backgroundImage: `url('${item.photo == null ? '': period.background_image.meta.download_url}')`,
              // backgroundColor: `${period.period_color}`,
              backgroundBlendMode: "soft-light",
              width: '100vw'
            }}
          >
            {/* <EventsBackgroundColor category={categoryColor} className={"h-100 overflow-scroll "}> */}
            
            <div class="padding-6 event-container">
            <div className={`m-auto ${eventItem.photo == null ? 'center-div' : ''}`}>
              {eventItem.photo == null || eventItem.photo == '' ? '' : 
                  (
                <div className={`${eventItem.photo.width > eventItem.photo.height && eventItem.photo.height < 450? 'col-8 col-lg-8 col-xl-8 m-auto p-0 landscape' : eventItem.photo.width < eventItem.photo.height && eventItem.photo.height >= 450 ? 'col-8 col-lg-3 col-xl-3 m-auto p-0 portrait' : 'col-8 col-lg-3 col-xl-3 m-auto p-0 even'}`}>
                    <div className="pt-1">
                      <div class="">
                        {/* <a href={item.photo.url} data-lightbox={item.id} data-title={item.caption}> */}
                          <img className="w-100 img-sample" src={eventItem.photo.url} />
                        {/* </a> */}
                      </div>
                    </div>
                    <div class="">
                      {/* <p class='font-style-7 text-white m-auto pt-1 text-left photo-caption'>{item.caption}</p> */}
                      <div className="font-style-7 text-white m-auto pt-1" dangerouslySetInnerHTML={{ __html: `${eventItem.caption == "" || eventItem.caption == null
                                      ? eventItem.photo.caption == null || eventItem.photo.caption == "" ? '' : eventItem.photo.caption
                                      : eventItem.caption}` }} />
                      
                    </div>
                </div>
              )
            }
            
            <Grid className="m-0 pb-5">
              <Grid.Column className="col-xl-10 col-lg-9 col-md-9 col-sm-10 mt-0 ml-3 px-0 pb-0 pt-2 m-auto">
                <div className="mt-4">
                  <p className="period-event-title-historical text-white mt-3">
                    {eventItem.display_name == "" || eventItem.display_name == null
                                      ? eventItem.complete_start_date
                                      : eventItem.display_name}
                    <span className={`period-event-category text-white  ${getCategory(eventItem.categories[0].pk) == '' ? "d-none" : ""}`}>| {getCategory(eventItem.categories[0].pk)}</span>
                  </p>
                </div>
                <div className="col-md-6 mt-2 p-0">
                  <hr className="hr-gold my-2" />
                </div>
    
                <div class="" onClick={(event) => this.handleLinkClick(event, `eventLink${period.id}-${eventItem.categories[0].pk}-${eventItem.id}`)} className="linkActiveEvent" id={`eventLink${ period.id + "-" + eventItem.categories[0].pk + "-" + eventItem.id}`}>
                  <p className="period-event-description-historical text-white font-style-3">
                    {/* {item.description.replace(regex, "")} */}
                    <div dangerouslySetInnerHTML={{ __html: `${eventItem.description}` }} />
                  </p>
                </div>

              </Grid.Column> 
            </Grid>
          </div>
          </div>
          {/* </EventsBackgroundColor> */}
          
          <div class="zIndex-999">
            <div class="">
              <Link className="link-event" to={{
                  pathname: `/epa_timeline/#event${period.id}-${eventItem.categories[0].pk}-${eventItem.id}`,
                  state: {
                    periodId:  period.id, 
                    categoryId:  eventItem.categories[0].pk, 
                    categoryName:  getCategory(eventItem.categories[0].pk), 
                    eventId: eventItem.id
                  }
                }}>
                <Button className="top-left-corner rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down" onClick={this.handleClick.bind(this, period.id, eventItem.categories[0].pk, eventItem.id)}>
                {/* <Button className="rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down"> */}
                  <Icon name="long arrow alternate left" />
                  Back
                </Button>
              </Link>
            </div>
          </div> 
          <div class="">
            <div class="">
              <p className="top-right-corner event-slider-period-category text-white text-uppercase text-right ">
                    {period.period_slider_display_name}
              </p>
            </div>
          </div> 
        </div>
      </div>
        )}
      </div>
    );
  }
}

export default EventSliderIndex;

const CatWithImage = props => {
  // console.log("CatWithImagessssss", props);
  var { eventItem, period, eventId } = props;
  var category = getCategory(eventItem.categories[0].id);
  // var category = eventItem.categories[0];
  var categoryColor = "";

  var startDateDisplay = eventItem.dates.map(item => {
    if (item.type == "start_date") {
      return item.value.year;
    }
  });
  const regex = /(<([^>]+)>)/gi;
  return (
    <div
      className="container-fluid col-xl-12 h-100 period-container bg-img p-0 sss"
      style={{
        backgroundImage: `url('${period.background_image.meta.download_url}')`,
        backgroundColor: `${period.period_color}`,
        backgroundBlendMode: "soft-light"
      }}
    > 
    {/* {isBrowser ? "h-100" : "vh-100"}
    {withOrientationChange ? "h-100" : "vh-100"} */}
      <EventsBackgroundColor category={categoryColor} className={"period-container"}>
     
      {/* <EventsBackgroundColor category={category} height={"h-100"}> */}
        <Grid className="m-0 p-3">
            <Grid.Column width={6}>
              <Button className="rounded-0 btn-event-back p-1 font-weight-bold" content="Scroll Down" onClick={props.handleClick.bind(this, eventItem.id)}>
                <Icon name="long arrow alternate left" />
                Back
              </Button>
            </Grid.Column>
            <Grid.Column width={10}>
              <p className="event-slider-period-category text-white text-uppercase text-right ">
                {period.period_slider_display_name}
              </p>
            </Grid.Column>
          </Grid>
        <div className="pt-5 center-div">
        <Grid className="m-0">
          <Grid.Column width={16} className="p-0">
            <img className="event-slider-image" align="left" src={eventItem.photo.url} />
            
          </Grid.Column>
          {/* <p className="font-style-7 text-white m-auto pt-1">{eventItem.photo.caption}</p> */}
          <div className="font-style-7 text-white m-auto pt-1" dangerouslySetInnerHTML={{ __html: `${eventItem.photo.caption}` }} />
        </Grid>
        <Grid className="m-0">
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={12} className="p-0">
            <p className="event-title-header text-white mt-3">
            {eventItem.display_name == "" || eventItem.display_name == null
                              ? eventItem.start_date
                              : eventItem.display_name}
              <span className={`event-category text-white  ${category == '' ? "d-none" : ""}`}>| {category}</span>
            </p>
            <div className="col-md-6 mt-2 p-0">
              <hr className="hr-gold" />
            </div>

            <p className="event-slider-category-description text-white">
              {/* {eventItem.description.replace(regex, "")} */}
              <div dangerouslySetInnerHTML={{ __html: `${eventItem.description}` }} />
            </p>
          </Grid.Column>
          <Grid.Column width={2}></Grid.Column>
        </Grid>
        </div>
      </EventsBackgroundColor>
    </div>
  );
};

const CatDescription = props => {
  // console.log("CatDescription", props)
  var { eventItem, period } = props;
  // console.log("CatDescriptionID", categories(eventItem.categories[0].id))
  // var category = eventItem.categories[0];
  var category = getCategory(eventItem.categories[0].id);
  var categoryColor = "";
  var startDateDisplay = eventItem.dates.map(item => {
    if (item.type == "start_date") {
      return item.value.year;
    }
  });
  const regex = /(<([^>]+)>)/gi;
  return (
    <div
      className="container-fluid col-xl-12 h-100 period-container bg-img p-0 ss2"
      style={{
        backgroundImage: `url('${period.background_image.meta.download_url}')`,
        backgroundColor: `${period.period_color}`,
        backgroundBlendMode: "soft-light"
      }}
    >
      <EventsBackgroundColor category={categoryColor} className={"period-container"}>
      
        <Grid className="m-0 p-3">
          <Grid.Column width={6}>
            <Button className="rounded-0 btn-event-back p-1 font-weight-bold" content="Scroll Down" onClick={props.handleClick.bind(this, eventItem.id)}>
              <Icon name="long arrow alternate left" />
              Back
            </Button>
          </Grid.Column>
          <Grid.Column width={10}>
            <p className="event-slider-period-category text-white text-uppercase text-right ">
              {period.period_slider_display_name}
            </p>
          </Grid.Column>
        </Grid>
        <div className="center-div">
        <Grid className="m-0">
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={12} className="p-0">
            <p className="event-title-header text-white">
            {eventItem.display_name == "" || eventItem.display_name == null
                              ? eventItem.start_date
                              : eventItem.display_name}
              <span className={`event-category text-white  ${category == '' ? "d-none" : ""}`}>| {category}</span>
            </p>

            <div className="col-md-6 mt-2 p-0">
              <hr className="hr-gold" />
            </div>

            <p className="event-slider-category-description text-white">
              {/* {eventItem.description.replace(regex, "")} */}
              <div dangerouslySetInnerHTML={{ __html: `${eventItem.description}` }} />
            </p>
          </Grid.Column>
          <Grid.Column width={2}></Grid.Column>
        </Grid>
        </div>
      </EventsBackgroundColor>
    </div>
  );
};
